import ModelBaseClass from "@quasidea/oas-client-react/lib/ModelBaseClass";
import CashProcessingBatchSearchResponse from "../CashProcessingBatchSearchResponse";
import ModelProxyClass from "./ModelProxyClass";
import CashProcessingBatch from "../CashProcessingBatch";


/**
 * @class CashProcessingBatchSearchResponseBase
 * @extends ModelBaseClass
 * @property {[CashProcessingBatch]} cashProcessingBatches
 * @property {number} totalItemCount (int64)
 */
class CashProcessingBatchSearchResponseBase extends ModelBaseClass {
	/**
	 * @type {[CashProcessingBatch]} cashProcessingBatches
	 */
	cashProcessingBatches;
	/**
	 * @type {number} totalItemCount (int64)
	 */
	totalItemCount;

	/**
	 * Instantiates a new instance of CashProcessingBatchSearchResponse based on the generic object being passed in (typically from a JSON object)
	 * @param {object} genericObject
	 * @return {CashProcessingBatchSearchResponse}
	 */
	static create(genericObject) {
		const newCashProcessingBatchSearchResponse = new CashProcessingBatchSearchResponse();
		newCashProcessingBatchSearchResponse.instantiate(_modelDefinition, genericObject, ModelProxyClass.createByClassName);
		return newCashProcessingBatchSearchResponse;
	}

	/**
	 * Instantiates a new array of CashProcessingBatchSearchResponse based on the generic array being passed in (typically from a JSON array)
	 * @param {[object]} genericArray
	 * @return {[CashProcessingBatchSearchResponse]}
	 */
	static createArray(genericArray) {
		if (genericArray === null) {
			return null;
		}

		const newCashProcessingBatchSearchResponseArray = [];
		genericArray.forEach(genericObject => {
			newCashProcessingBatchSearchResponseArray.push(CashProcessingBatchSearchResponse.create(genericObject));
		});
		return newCashProcessingBatchSearchResponseArray;
	}
}

const _modelDefinition = [
	ModelBaseClass.createModelProperty('cashProcessingBatches', '[CashProcessingBatch]'),
	ModelBaseClass.createModelProperty('totalItemCount', 'integer'),
];

export default CashProcessingBatchSearchResponseBase;
